import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import DanAppStart from "./component/startPage";
import LoginDan from "./component/login";
import RegisterDan from "./component/register";
import RegOtptDan from "./component/register-otp";
import ForgetDan from './component/forget';
import HomeDan from "./component/panel/home";
import GiftsDan from "./component/panel/gifts";
import ShopsDan from "./component/panel/shops";
import CardsDan from "./component/panel/cards";
import ProfileDan from "./component/panel/profile";
import Layout from "./component/Layout";
import ForgetOtptDan from "./component/forget-otp";
import NewPasstDan from "./component/new-pass";
import RegformDan from "./component/register-form";
import ReffralDan from "./component/panel/reffral-list";
import TransactionsDan from "./component/panel/transactions";
import AddBankDan from "./component/panel/add-bank";
import VipDan from "./component/panel/vip";
import TarmsDan from "./component/panel/tarms";
import TarmsReg from "./component/tarms-reg";
import Abutus from "./component/panel/about";
import Tamasbama from "./component/panel/tamasbama";



function App() {
  return (
    <Router future={{ v7_startTransition: true }}>
      <Routes>
        {/* مسیرهای بدون هدر و فوتر ثابت */}
        <Route path="/" element={<DanAppStart />} />
        <Route path="/login" element={<LoginDan />} />
        <Route path="/register" element={<RegisterDan />} />
        <Route path="/forget" element={<ForgetDan />} />
        <Route path="/register-otp" element={<RegOtptDan />} />
        <Route path="/forget-otp" element={<ForgetOtptDan />} />
        <Route path="/new-pass" element={<NewPasstDan />} />
        <Route path="/register-form" element={<RegformDan />} />
        <Route path="/panel/reffral-list" element={<ReffralDan />} />
        <Route path="/panel/transactions" element={<TransactionsDan />} />
        <Route path="/panel/add-bank" element={<AddBankDan />} />
        <Route path="/panel/vip" element={<VipDan />} />
        <Route path="/tarms-reg" element={<TarmsReg />} />


        {/* مسیرهای دارای هدر و فوتر */}
        <Route path="/panel" element={<Layout />}>
          <Route path="home" element={<HomeDan />} />
          <Route path="gifts" element={<GiftsDan />} />
          <Route path="shops" element={<ShopsDan />} />
          <Route path="cards" element={<CardsDan />} />
          <Route path="profile" element={<ProfileDan />} />
          <Route path="tarms" element={<TarmsDan />} />
          <Route path="about" element={<Abutus />} />
          <Route path="tamasbama" element={<Tamasbama />} />

          



  
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
